// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.production.ts`.
// The list of file replacements can be found in `angular.json`.

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */

import { EnvironmentInterface } from './EnvironmentInterface';

export const environment: EnvironmentInterface = {
  ALLOW_CASES_DEPARTMENTS_IDS: [],
  ALLOW_CASES_ROLES_IDS: [],
  BLOCK_CASES_STATUS_IDS: [],
  MANAGER_USER_IDS: [],
  CLIENT_APP_URL:      'http://client.stage.unifye.com',
  API_SECURE_PROTOCOL: true,
  APP_NAME:            'Unifye',
  /*APP_TYPE:              'debt',*/
  APP_ENV:               'local',
  production:            false,
  devMode:               true,
  API_DOMAIN:            'api.stage.unifye.com',
  API_URL:               'https://api.stage.unifye.com',
  STORAGE_URL:           'https://api.stage.unifye.com/storage',
  APP_URL:               'https://app.stage.unifye.com',
  GENERAL_SITE_URL:      'www.unifye.es',
  REFRESH_NOTIFICATIONS: false,
  DISTRIBUTION_USER_IDS: [1, 27, 36, 2403, 2497],

  COMPANY_NAME:        'Unifye',
  COMPANY_NAME_LEGAL:  'Unifye Reparadora Legal Group, S.L.',
  COMPANY_ID_CIF:      'B88315890',
  COMPANY_ADDRESS:     'Avenida de la Vega, núm. 15, Edificio 2, planta 4ª, Alcobendas (Madrid), CP 28108]',
  COMPANY_BANK_NAME:   'Caixabank',
  COMPANY_BANK_IBAN:   'ES06 2100 4910 3613 0024 6367',
  COMPANY_PHONE_LEGAL: '910 053 393',

  VAT_PERCENTAGE: 21,

  EMAIL_INFO:                 'info@deudafix.es',
  EMAIL_LEGAL:                'legal@deudafix.es',
  EMAIL_ADMINISTRATION:       'administracion@deudafix.es',
  EMAIL_CANCELLATIONS:        'cancelaciones@deudafix.es',
  EMAIL_CONTRACT_CONTACT:     'contract@deudafix.com',
  EMAIL_SUPPORTING_DOCUMENTS: 'justificantes@deudafix.es',
  EMAIL_GDPR:                 'dataprotectionofficer@deudafix.es',

  GOOGLE_ANALYTICS_CODE:    'XXXXG-NPW7ZJLJHP',
  GOOGLE_ANALYTICS_ENABLED: false
};
